// React
import PropTypes from "prop-types";
import { useContext } from "react";
import { UserContext } from "context/user";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "80%", xxl: "70%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalDomicilio({
  open,
  handleClose,
  empresa,
  setEmpresa,
  finalizada,
  user,
  onSave,
  saving,
}) {
  const { verificarAcceso } = useContext(UserContext);
  const handleChangeEmpresa = (e) => {
    setEmpresa({
      ...empresa,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center">
              <SoftTypography variant="h6"></SoftTypography>
              <Tooltip title="Cerrar" placement="top">
                <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                  close
                </Icon>
              </Tooltip>
            </SoftBox>
            {verificarAcceso(207) ? (
              <SoftBox py={3}>
                <Grid container spacing={2}>
                  {/* Domicilio legal */}
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                      <SoftTypography variant="h5" fontWeight="bold">
                        Domicilio Legal
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="calleLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Calle
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="calleLegal"
                      placeholder="Calle"
                      value={empresa?.calleLegal || ""}
                      fullWidth
                      name="calleLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="localidadLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Localidad
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="localidadLegal"
                      placeholder="Localidad"
                      value={empresa?.localidadLegal || ""}
                      fullWidth
                      name="localidadLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="cpLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Código postal
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="cpLegal"
                      placeholder="CP"
                      value={empresa?.cpLegal || ""}
                      fullWidth
                      name="cpLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="provinciaLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Provincia
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="provinciaLegal"
                      placeholder="Provincia"
                      value={empresa?.provinciaLegal || ""}
                      fullWidth
                      name="provinciaLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="departamentoLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Departamento
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="departamentoLegal"
                      placeholder="Departamento"
                      value={empresa?.departamentoLegal || ""}
                      fullWidth
                      name="departamentoLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="telefonoLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Teléfono
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="telefonoLegal"
                      placeholder="Teléfono"
                      value={empresa?.telefonoLegal || ""}
                      fullWidth
                      name="telefonoLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="faxLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Fax
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="faxLegal"
                      placeholder="Fax"
                      value={empresa?.faxLegal || ""}
                      fullWidth
                      name="faxLegal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  {/* Domicilio Real */}
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                      <SoftTypography variant="h5" fontWeight="bold">
                        Domicilio Real
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="calleReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Calle
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="calleReal"
                      placeholder="Calle"
                      value={empresa?.calleReal || ""}
                      fullWidth
                      name="calleReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="localidadReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Localidad
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="localidadReal"
                      placeholder="Localidad"
                      value={empresa?.localidadReal || ""}
                      fullWidth
                      name="localidadReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="cpReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Código postal
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="cpReal"
                      placeholder="CP"
                      value={empresa?.cpReal || ""}
                      fullWidth
                      name="cpReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="provinciaReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Provincia
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="provinciaReal"
                      placeholder="Provincia"
                      value={empresa?.provinciaReal || ""}
                      fullWidth
                      name="provinciaReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="departamentoReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Departamento
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="departamentoReal"
                      placeholder="Departamento"
                      value={empresa?.departamentoReal || ""}
                      fullWidth
                      name="departamentoReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="telefonoReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Teléfono
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="telefonoReal"
                      placeholder="Teléfono"
                      value={empresa?.telefonoReal || ""}
                      fullWidth
                      name="telefonoReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="faxReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Fax
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      id="faxReal"
                      placeholder="Fax"
                      value={empresa?.faxReal || ""}
                      fullWidth
                      name="faxReal"
                      onChange={handleChangeEmpresa}
                    />
                  </Grid>
                </Grid>
              </SoftBox>
            ) : (
              <SoftBox py={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                      <SoftTypography variant="h5" fontWeight="bold">
                        Domicilio Legal
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="calleLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Calle
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.calleReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="localidadLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Localidad
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.localidadReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="cpLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Código postal
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.cpReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="provinciaLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Provincia
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.provinciaReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="departamentoLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Departamento
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.departamentoReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="telefonoLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Teléfono
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.telefonoReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="faxLegal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Fax
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.faxReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  {/* Domicilio Real */}
                  <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                      <SoftTypography variant="h5" fontWeight="bold">
                        Domicilio Real
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="calleReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Calle
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.calleReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="localidadReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Localidad
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.localidadReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="cpReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Código postal
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.cpReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="provinciaReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Provincia
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.provinciaReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel htmlFor="departamentoReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Departamento
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.departamentoReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="telefonoReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Teléfono
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.telefonoReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="faxReal">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Fax
                      </SoftTypography>
                    </InputLabel>
                    <SoftTypography variant="body2" fontWeight="bold">
                      {empresa?.faxReal || "Sin datos"}
                    </SoftTypography>
                  </Grid>
                </Grid>
              </SoftBox>
            )}

            <SoftBox display="flex" justifyContent="flex-end" alignItems="center">
              <SoftButton color="gobSecondary" disabled={saving} onClick={verificarAcceso(207) && !finalizada ? onSave : handleClose}>
                {/* <Icon sx={{ fontWeight: "light" }}>save</Icon> */}
                {verificarAcceso(207) && !finalizada ? "Guardar cambios" : "Cerrar"}
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalDomicilio.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  empresa: PropTypes.object,
  setEmpresa: PropTypes.func,
  finalizada: PropTypes.bool,
  onSave: PropTypes.func,
  saving: PropTypes.bool,
  user: PropTypes.object.isRequired,
};
